var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidemenuOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22758 6.10352e-05H1.77237C0.793604 6.10352e-05 0.000244141 0.793421 0.000244141 1.77219L0.000244141 8.22775C0.000244141 9.20651 0.793604 9.99987 1.77237 9.99987H8.22793C9.2067 9.99987 10.0001 9.20651 10.0001 8.22775L10.0001 1.77219C10.0001 0.793421 9.2067 6.10352e-05 8.22793 6.10352e-05H8.22758ZM1.1113 8.2274L1.1113 1.77219C1.1113 1.40762 1.40781 1.11111 1.77237 1.11111H2.88203L2.88203 8.88847H1.77237C1.40781 8.88847 1.1113 8.59196 1.1113 8.2274ZM8.88866 8.2274C8.88866 8.59196 8.59215 8.88847 8.22758 8.88847H3.99309L3.99309 1.11111H8.22758C8.59215 1.11111 8.88866 1.40762 8.88866 1.77219L8.88866 8.22775V8.2274Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69379 6.80621C5.55179 6.80621 5.40943 6.75205 5.30111 6.64337C5.0841 6.42637 5.0841 6.07466 5.30111 5.85765L6.15835 5.00041L5.30111 4.14316C5.0841 3.92616 5.0841 3.57444 5.30111 3.35744C5.51811 3.14044 5.86983 3.14044 6.08683 3.35744L7.33676 4.60737C7.55376 4.82438 7.55376 5.17609 7.33676 5.39309L6.08683 6.64303C5.9785 6.75136 5.83615 6.80587 5.69414 6.80587L5.69379 6.80621Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenuOpenIcon);
export default __webpack_public_path__ + "static/media/SidemenuOpenIcon.ccff248b30a3ffa5b3c2a1fe74022e92.svg";
export { ForwardRef as ReactComponent };